module.exports = __webpack_public_path__ + "static/extra_1-99bd0a6c44fdd1c05f3f61b45c4d5cb3.jpg";